import React, {Component} from 'react';
import {Platform, StyleSheet, Text, View, ScrollView, TouchableOpacity} from 'react-native';

import Colors from "../tools/Colors";
import {moderateScale} from "../tools/Scaling";
import HMTextView from "./HMTextView";
import HMIcon from "./HMIcon";
// import Icon from 'react-native-vector-icons/FontAwesome';
// import Ionicons from 'react-native-vector-icons/Ionicons';
// import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
// import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';


export default class HMItem extends Component {

    render() {

        const {style, text, icon, navigateParams, typeIcon,cammas} = this.props;
        return (
            <TouchableOpacity
                style={[{
                    flexDirection: 'row',
                    //  //justifyContent: "flex-end",
                    //alignItems: "flex-start",
                    width:'94%',
                    height: moderateScale(48),
                    // margin: moderateScale(4),
                    alignSelf: 'center',
                    marginHorizontal: moderateScale(10), alignItems: 'center'
                }, style]}
                onPress={
                    navigateParams
                }>
                <HMTextView
                    cammas={cammas}
                    text={text} style={{
                    alignSelf: 'center',
                    //  marginRight: moderateScale(6),
                    // margin: moderateScale(6),
                    textAlign: 'center',
                    color: Colors.colorDarkText,
                    fontSize: moderateScale(16),
                }}/>
                <View style={{flex: 1}}/>
                <HMIcon name={icon}
                        type={typeIcon?typeIcon:"FontAwesome"}
                        style={{
                            textAlign: 'center',
                            //alignSelf: 'flex-end',
                            color: Colors.gray,
                            width: moderateScale(29),
                            height: moderateScale(29),
                            fontSize: moderateScale(24)
                        }}/>
                {/*          {
                    this.getIcon(typeIcon, icon)
                }*/}
                {/*<Icon name={icon} style={{*/}
                {/*textAlign: 'center',*/}
                {/*//alignSelf: 'flex-end',*/}
                {/*color: Colors.gray,*/}
                {/*width: moderateScale(29),*/}
                {/*height: moderateScale(29),*/}
                {/*fontSize: moderateScale(24)*/}
                {/*}}/>*/}


            </TouchableOpacity>
        );
    }


}
